import actions from 'actions/orders/orderSuppliers'
import { createChildFormViewContainer } from 'factories/ChildFormView'
import Component from 'components/Orders/Suppliers/FormView'

export default createChildFormViewContainer({ actions })(Component)
